import { baseEramHubConnection, EramMessageProcessingError } from "./eramHubConnectionFactory";
import { setEligibilityPrompt, setIsProcessingCommand, setMcaFeedback, setMraMessage, } from "./eramReact/slices/messagingSlice";
import { genericReject } from "@poscon/shared-types/eram";
import { dispatchCommandRecall } from "./customEvents";
export const processEramMessage = (message, client, sentFromGraphicalMenu = true) => {
    return async (dispatch) => {
        dispatch(setIsProcessingCommand(true));
        const { recall, response, eligibilityPrompt, ...result } = await baseEramHubConnection
            .processEramMessage(message.filter((t) => !t.token?.match(/^\s*$/)), client, sentFromGraphicalMenu)
            .catch((e) => {
            if (e instanceof EramMessageProcessingError) {
                return e.result;
            }
            return genericReject([], "REJECT - UNKNOWN ERROR");
        });
        dispatch(setMcaFeedback(result));
        if (response) {
            dispatch(setMraMessage(response));
        }
        if (eligibilityPrompt) {
            dispatch(setEligibilityPrompt(eligibilityPrompt));
        }
        dispatchCommandRecall(recall);
        dispatch(setIsProcessingCommand(false));
        return Promise.resolve(result.isSuccess ?? false);
    };
};
//# sourceMappingURL=processEramMessage.js.map